import { ActionIcon, Menu } from '@mantine/core';
import { IconDotsVertical, IconMessage, IconTransfer } from '@tabler/icons-react';
import type { MouseEvent } from 'react';
import { FEATURE_VISIBILITY } from '@/config/featureVisibility';

function stopRowActivation(e: React.KeyboardEvent) {
  if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
}

interface CaseloadRowActionsMenuProps {
  onTransfer: (event: MouseEvent) => void;
  onMessage: (event: MouseEvent) => void;
}

/** 3-dot row menu shared by caseload tables (Transfer + Message). */
export function CaseloadRowActionsMenu({
  onTransfer,
  onMessage,
}: CaseloadRowActionsMenuProps): JSX.Element {
  return (
    <Menu shadow="md" width={180} position="bottom-end">
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          aria-label="Row actions"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={stopRowActivation}
        >
          <IconDotsVertical size={16} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item leftSection={<IconTransfer size={16} />} onClick={onTransfer}>
          Transfer
        </Menu.Item>
        {FEATURE_VISIBILITY.staffMessages ? (
          <Menu.Item
            leftSection={<IconMessage size={16} />}
            onClick={(e) => {
              onMessage(e);
            }}
          >
            Message
          </Menu.Item>
        ) : null}
      </Menu.Dropdown>
    </Menu>
  );
}
